export default (messageOrKey: string): string => {
  const parsedMessageOrKey = `${messageOrKey}`.trim();

  if (!parsedMessageOrKey.length) {
    throw new Error('There must be a message or key provider to the validation error message factory function');
  }

  return `answer-validation__${parsedMessageOrKey}`.replace(/\s+/gm, '-').toLowerCase();
};
